import { ChangeDetectionStrategy, Component, inject, Input, signal, WritableSignal } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { VenueIconLibraryService } from '@services/venue-icon-library.service';

@Component({
    selector: 'app-venue-icon',
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './venue-icon.component.html',
    styleUrl: './venue-icon.component.css'
})
export class VenueIconComponent {

  // SERVICES
  private readonly sanitizer: DomSanitizer            = inject(DomSanitizer);
  private readonly library:   VenueIconLibraryService = inject(VenueIconLibraryService);

  // COMPONENT STATE
  // Signal: el markup se resuelve async y el componente es OnPush.
  protected readonly html: WritableSignal<SafeHtml> = signal<SafeHtml>('');

  // Descarta resoluciones obsoletas si `id` cambia durante la carga.
  private requested: number = 0;

  // INPUTS
  /**
   * `string` (no `VenueIconId`): el valor viene de config, donde puede ser '' o un id retirado.
   * Setter y no getter: `bypassSecurityTrustHtml` devuelve un objeto nuevo cada vez, y un
   * getter volveria a enlazar `[innerHTML]` en cada ciclo de deteccion de cambios.
   */
  @Input()
  public set id(value: string | null | undefined) {

    const token: number = ++this.requested;

    if(!value){ this.html.set(''); return; }

    this.library.load().then((map: Record<string, string>): void => {

      if(token !== this.requested) return;

      // Solo se sanea markup de VENUE_ICONS (constantes del repo), nunca entrada de config/usuario.
      this.html.set(this.sanitizer.bypassSecurityTrustHtml(map[value] || ''));

    });

  }

}
